// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"O1-z","dimensionLabel":"P1-z","styleChooserControlWrapper":"Q1-z","styleChooserControl":"R1-z","disabled":"S1-z","giftCard":"T1-z","styleChooserText":"U1-z"};